<template>
  <div class="freight-table-carriers">
    <BaseDataTable
      :columns="columns"
      :items="items"
      :row-key="rowKey"
      :loading="loading"
      :pagination="pagination"
      :scroll="scroll"
      selectable
      :selected-row-keys="selectedRowKeys"
      @change="onTableChange"
      @selection-change="$emit('selection-change', $event)"
    >
      <template slot="transportadora" slot-scope="text, record">
        <div class="freight-table-carriers__carrier">
          <span class="freight-table-carriers__carrier-name" :title="record.nome">
            {{ record.nome }}
          </span>
          <span class="freight-table-carriers__carrier-doc">
            {{ record.documento }}
          </span>
        </div>
      </template>

      <template slot="status" slot-scope="text, record">
        <StatusBadge :label="record.status" :active="isActive(record)" />
      </template>

      <template slot="acoes" slot-scope="text, record">
        <a-tooltip
          :title="isActive(record) ? 'Inativar transportadora' : 'Ativar transportadora'"
          placement="left"
        >
          <a-switch
            class="freight-table-carriers__switch"
            :checked="isActive(record)"
            @change="$emit('toggle-status', { record, active: !isActive(record) })"
          />
        </a-tooltip>
      </template>
    </BaseDataTable>
  </div>
</template>

<script>
import BaseDataTable from "@/shared/components/BaseDataTable.vue";
import StatusBadge from "@/shared/components/StatusBadge.vue";
import { FREIGHT_TABLE_STATUS } from "../../constants/freightTableStatus";

export default {
  name: "FreightTableCarriersTable",
  components: { BaseDataTable, StatusBadge },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    rowKey: {
      type: String,
      default: "id",
    },
    selectedRowKeys: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      default: () => ({ current: 1, perPage: 10, total: 0 }),
    },
  },
  data() {
    return {
      scroll: { x: 1276 },
      columns: [
        {
          title: "Transportadora",
          key: "transportadora",
          width: 340,
          scopedSlots: { customRender: "transportadora" },
        },
        {
          title: "Município",
          dataIndex: "municipio",
          key: "municipio",
          width: 345,
        },
        {
          title: "Inscrição estadual",
          dataIndex: "inscricaoEstadual",
          key: "inscricaoEstadual",
          width: 344,
        },
        {
          title: "Status",
          key: "status",
          width: 118,
          scopedSlots: { customRender: "status" },
        },
        {
          title: "Ações",
          key: "acoes",
          width: 81,
          scopedSlots: { customRender: "acoes" },
        },
      ],
    };
  },
  methods: {
    isActive(record) {
      return Number(record.statusValor) === FREIGHT_TABLE_STATUS.ATIVA;
    },
    onTableChange({ page, perPage }) {
      this.$emit("table-change", { page, perPage });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-carriers {
  &__carrier {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__carrier-name {
    color: @color-text-dark;
    font-weight: 600;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &__carrier-doc {
    font-size: 12px;
    color: @color-text-medium;
    margin-top: 2px;
  }

  &__switch {
    &.ant-switch-checked {
      background-color: @color-primary;
    }
  }
}
</style>
